// extracted by mini-css-extract-plugin
export default {"section":"SmsSendingStartSettingsTab_section__QrT7g","save_button":"SmsSendingStartSettingsTab_save_button__zJQxj"};